import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActividadesAplicacionThunk } from "../store/reducers/actividadesAplicacion/actividadesAplicacion.thunks";
import ActivitiesApplicationHeader from "./activities-application/ActivitiesApplicationHeader";
import ActivitiesApplicationTable from "./activities-application/ActivitiesApplicationTable";
import ActivitiesApplicationViewModal from "./activities-application/ActivitiesApplicationViewModal";
import ActivitiesApplicationFormModal from "./activities-application/ActivitiesApplicationFormModal";
import ActivitiesApplicationConfirmToggleModal from "./activities-application/ActivitiesApplicationConfirmToggleModal";
import Loader from "./UI/Loader";
import Alert from "./UI/Alert";
import Pagination from "./UI/Pagination";
import {
  clearActividadesAplicacionError,
  setPage,
} from "../store/reducers/actividadesAplicacion/actividadesAplicacion.reducer";
import EmptyState from "./UI/EmptyState";
import { Icon } from "@iconify/react";

const ActivitiesApplicationListLayer = () => {
  const dispatch = useDispatch();
  const { list, loading, error, page, pageSize, search, talentoFilter, count } =
    useSelector((state) => state.actividadesAplicacion);

  useEffect(() => {
    dispatch(
      getActividadesAplicacionThunk({ page, search, talento: talentoFilter }),
    );
  }, [dispatch, page, search, talentoFilter]);

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <ActivitiesApplicationHeader />

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearActividadesAplicacionError())}
          />
        )}

        {loading ? (
          <Loader center text="Cargando actividades..." delay={200} />
        ) : (
          <>
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {list.length === 0 ? (
              <EmptyState
                icon={
                  search || talentoFilter
                    ? "mdi:magnify-remove-outline"
                    : "mdi:checkbox-marked-circle-outline"
                }
                title={
                  search || talentoFilter
                    ? "No se encontraron actividades"
                    : "No hay actividades registradas"
                }
                description={
                  search || talentoFilter
                    ? "Intenta con otra búsqueda o filtro"
                    : "Comienza agregando una nueva actividad"
                }
              />
            ) : (
              <>
                <ActivitiesApplicationTable
                  actividades={list}
                  search={search}
                />
                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={(newPage) => dispatch(setPage(newPage))}
                />
              </>
            )}
          </>
        )}
      </div>

      <ActivitiesApplicationViewModal />
      <ActivitiesApplicationFormModal />
      <ActivitiesApplicationConfirmToggleModal />
    </div>
  );
};

export default ActivitiesApplicationListLayer;
